<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válasszon ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <div class="n-oldalfej"><h2>{{ nezetCim }}</h2><span class="n-alcim">Törzsadatok</span></div>

  <!-- ROVATOK -->
  <div *ngIf="nezet === 'rovat'">
    <div class="naplo-eszkozsor"><ion-button style="--background:var(--naplo)" (click)="ujRovat()"><ion-icon slot="start" name="add"></ion-icon> Új rovat</ion-button>
      <ion-button fill="outline" style="--color:var(--naplo); --border-color:var(--naplo)" (click)="alapRovatok()" title="A hiányzó fő rovatokat (bevétel + kiadás) tölti be"><ion-icon slot="start" name="download-outline"></ion-icon> Alaprovatok betöltése</ion-button></div>
    <div class="tabla-wrap">
      <table class="naplo-tabla">
        <thead><tr><th>Rovatszám</th><th>Név</th><th>Típus</th><th class="num">Oszlop</th><th>ÁFÁ-s</th><th class="num">Alap %</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let r of rovatok">
            <td>{{ r.rovatszam }}</td><td>{{ r.nev }}</td><td>{{ tipusCimke(opciok.rovatTipus, r.tipus) }}</td>
            <td class="num">{{ r.oszlop }}</td><td>{{ r.afas ? '✔' : '' }}</td><td class="num">{{ r.alap_afa_kulcs }}</td>
            <td><ion-button size="small" fill="clear" (click)="szerkRovat(r)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
              <ion-button size="small" fill="clear" color="danger" (click)="torol('rovat', r)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- OSZLOPOK -->
  <div *ngIf="nezet === 'oszlop'">
    <div class="naplo-eszkozsor">
      <ion-button style="--background:var(--naplo)" (click)="ujOszlop()" [disabled]="oszlopok.length >= 6"><ion-icon slot="start" name="add"></ion-icon> Oszlop-pár</ion-button>
      <ion-text color="medium" style="font-size:.82rem">Max. 6 követelés/kötelezettség oszlop-pár ({{ aktiv.ev }}).</ion-text>
    </div>
    <div class="tabla-wrap">
      <table class="naplo-tabla">
        <thead><tr><th class="num">#</th><th>Típus</th><th>Fejléc</th><th>Csökkenő (rovat/név)</th><th>Növekvő (rovat/név)</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let o of oszlopok">
            <td class="num">{{ o.sorszam }}</td><td>{{ tipusCimke(opciok.oszlopTipus, o.tipus) }}</td><td>{{ o.fejlec }}</td>
            <td>{{ o.csokkeno_rovat }} – {{ o.csokkeno_nev }}</td><td>{{ o.novekvo_rovat }} – {{ o.novekvo_nev }}</td>
            <td><ion-button size="small" fill="clear" (click)="szerkOszlop(o)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
              <ion-button size="small" fill="clear" color="danger" (click)="torol('oszlop', o)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- PARTNEREK -->
  <div *ngIf="nezet === 'partner'">
    <div class="naplo-eszkozsor"><ion-button style="--background:var(--naplo)" (click)="ujPartner()"><ion-icon slot="start" name="add"></ion-icon> Új partner</ion-button></div>
    <div class="tabla-wrap">
      <table class="naplo-tabla">
        <thead><tr><th class="num">Kód</th><th>Név</th><th>Adószám</th><th>Település</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let p of partnerek">
            <td class="num">{{ p.kod }}</td><td>{{ p.nev }}</td><td>{{ p.adoszam }}</td><td>{{ p.irsz }} {{ p.telepules }}</td>
            <td><ion-button size="small" fill="clear" (click)="szerkPartner(p)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
              <ion-button size="small" fill="clear" color="danger" (click)="torol('partner', p)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ÁFA-BEVALLÁSI SOROK (közös törzs: a számlasor „Bevallási sor kiválasztása" ablaka ebből választ) -->
  <div *ngIf="nezet === 'bevsor'">
    <div class="n-szuro-sor">
      <button type="button" class="ov-gomb fo" (click)="bevsorUj()"><ion-icon name="add"></ion-icon>Új bevallási sor</button>
      <button type="button" class="ov-gomb" (click)="bevsorNavbol()" title="Minden sor felvétele, amelyre a NAV eÁFA adókód-katalógusa hivatkozik (a meglévő megnevezések maradnak)">
        <ion-icon name="cloud-download-outline"></ion-icon>Feltöltés a NAV adókód-katalógusából</button>
      <input type="search" [(ngModel)]="bevsorKereso" placeholder="Keresés sorszámra, megnevezésre…">
      <span class="spacer"></span>
      <span class="halvany">Közös törzs minden ügyfélre. A sorszám a 65-ös ÁFA-bevallás sora.</span>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs bevsor-racs">
        <thead><tr><th style="width:90px">Sorszám</th><th>Megnevezés</th><th style="width:140px">Irány</th><th style="width:80px" class="num">Sorrend</th><th style="width:70px">Aktív</th><th style="width:150px"></th></tr></thead>
        <tbody>
          <tr *ngFor="let b of bevsorLathato" [class.kijelolt]="b._v">
            <td><input class="kv-cella kod" [(ngModel)]="b.kod" (ngModelChange)="b._v = true" maxlength="10"></td>
            <td><input class="kv-cella" [(ngModel)]="b.nev" (ngModelChange)="b._v = true"></td>
            <td><select class="kv-cella" [(ngModel)]="b.irany" (ngModelChange)="b._v = true">
              <option value="fizetendo">fizetendő</option><option value="levonhato">levonható</option><option [ngValue]="null">—</option></select></td>
            <td class="num"><input class="kv-cella num" type="number" [(ngModel)]="b.sorrend" (ngModelChange)="b._v = true"></td>
            <td><input type="checkbox" [(ngModel)]="b.aktiv" (ngModelChange)="b._v = true"></td>
            <td class="num">
              <button type="button" class="ov-gomb fo" *ngIf="b._v" [disabled]="!b.kod || !b.nev" (click)="bevsorMent(b)">Mentés</button>
              <button type="button" class="kv-torol" (click)="bevsorTorol(b)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="!bevsorok.length">Még nincs bevallási sor a törzsben.</div>
    </div>
  </div>

  <!-- ADÓKÓDOK: a NAV szabványos adókód-katalógusa (eÁFA) – közös, csak frissíthető -->
  <div *ngIf="nezet === 'adokod'">
    <div class="n-szuro-sor">
      <button type="button" class="ov-gomb fo" (click)="adokodFrissit()" [disabled]="adokodFrissul" title="A NAV nyilvános eVAT tárhelyének legfrissebb katalógusa">
        <ion-icon name="cloud-download-outline"></ion-icon>{{ adokodFrissul ? 'Letöltés…' : 'Frissítés a NAV-tól' }}</button>
      <input type="search" [(ngModel)]="adokodKereso" placeholder="Keresés: MD66, F29 66, fordított…">
      <span class="spacer"></span>
      <span class="halvany">NAV szabványos adókódok (eÁFA){{ adokodKatalogus ? ' · katalógus: ' + adokodKatalogus : '' }} · {{ adokodLathato.length }} kód</span>
    </div>
    <p class="n-megj" style="margin:8px 18px">Az eÁFA-ban a tételes analitika minden sora a NAV szabványos adókódját viszi – ebből dől el, a bevallás
      melyik sorába kerül. <b>MP</b> = fizetendő fősor, <b>MD</b> = levonható fősor, <b>DP/DD/DH</b> = részletező sorok, <b>PG</b> = melléklap.
      A NAV a listát rögzítettnek tekinti, ezért itt nem szerkeszthető.</p>
    <div class="tabla-wrap">
      <table class="n-racs bevsor-racs">
        <thead><tr><th style="width:190px">Standard adókód</th><th style="width:120px">Beszédes</th><th>Leírás</th><th style="width:260px">Bevallási sorok</th></tr></thead>
        <tbody>
          <tr *ngFor="let a of adokodLathato">
            <td><b>{{ a.kod }}</b></td><td>{{ a.beszedes }}</td><td>{{ a.leiras }}</td><td class="halvany">{{ adokodSorok(a) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="!adokodok.length">A katalógus még üres – „Frissítés a NAV-tól”.</div>
    </div>
  </div>

  <!-- MUNKASZÁMOK (kettős, ügyfélszintű törzs: a könyvelőablak és a kivonat szűkítése ebből választ) -->
  <div *ngIf="nezet === 'munkaszam'">
    <div class="n-szuro-sor">
      <button type="button" class="ov-gomb fo" (click)="munkaszamUj()"><ion-icon name="add"></ion-icon>Új munkaszám</button>
      <span class="spacer"></span>
      <span class="halvany">Munka, telephely, projekt vagy pályázat szerinti gyűjtés. A kód betűt és számot is tartalmazhat.</span>
    </div>
    <div class="tabla-wrap">
      <table class="n-racs bevsor-racs">
        <thead><tr><th style="width:140px">Kód</th><th>Megnevezés</th><th style="width:150px"></th></tr></thead>
        <tbody>
          <tr *ngFor="let m of munkaszamok" [class.kijelolt]="m._v">
            <td><input class="kv-cella kod" [(ngModel)]="m.kod" (ngModelChange)="m._v = true" maxlength="10" placeholder="pl. P2026-01" [readonly]="!!m.id"></td>
            <td><input class="kv-cella" [(ngModel)]="m.nev" (ngModelChange)="m._v = true" maxlength="30" placeholder="pl. Budaörsi telephely"></td>
            <td class="num">
              <button type="button" class="ov-gomb fo" *ngIf="m._v" [disabled]="!m.kod" (click)="munkaszamMent(m)">Mentés</button>
              <button type="button" class="kv-torol" (click)="munkaszamTorol(m)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ures" *ngIf="!munkaszamok.length">Még nincs munkaszám a törzsben.</div>
    </div>
  </div>

  <!-- GYŰJTŐK -->
  <div *ngIf="nezet === 'gyujto'">
    <div class="naplo-eszkozsor"><ion-button style="--background:var(--naplo)" (click)="ujGyujto()"><ion-icon slot="start" name="add"></ion-icon> Új gyűjtő</ion-button></div>
    <div class="tabla-wrap">
      <table class="naplo-tabla">
        <thead><tr><th>Kód</th><th>Név</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let g of gyujtok">
            <td>{{ g.kod }}</td><td>{{ g.nev }}</td>
            <td><ion-button size="small" fill="clear" (click)="szerkGyujto(g)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
              <ion-button size="small" fill="clear" color="danger" (click)="torol('gyujto', g)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- PÉNZTÁR/BANK -->
  <div *ngIf="nezet === 'penztar'">
    <div class="naplo-eszkozsor"><ion-button style="--background:var(--naplo)" (click)="ujPenztar()"><ion-icon slot="start" name="add"></ion-icon> Új pénztár/bank</ion-button></div>
    <div class="tabla-wrap">
      <table class="naplo-tabla">
        <thead><tr><th>Azon.</th><th>Név</th><th>Típus</th><th>Deviza</th><th class="num">Nyitó egyenleg</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let p of penztarak">
            <td>{{ p.azonosito }}</td><td>{{ p.nev }}</td><td>{{ tipusCimke(opciok.penztarTipus, p.tipus) }}</td><td>{{ p.devizanem }}</td>
            <td class="num">{{ p.nyito_egyenleg | number:'1.0-0' }}</td>
            <td><ion-button size="small" fill="clear" (click)="szerkPenztar(p)"><ion-icon slot="icon-only" name="create-outline"></ion-icon></ion-button>
              <ion-button size="small" fill="clear" color="danger" (click)="torol('penztar', p)"><ion-icon slot="icon-only" name="trash-outline"></ion-icon></ion-button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- OSA / NAV -->
  <!-- NAV TECHNIKAI FELHASZNÁLÓ: teszt és éles hitelesítő, váltással -->
  <div *ngIf="nezet === 'osa'" class="tech-oldal">
    <p class="halvany tech-info">
      Az ügyfél NAV-<b>technikai felhasználója</b>: ezzel húzzuk be a számlákat (Online Számla), töltjük le a
      pénztárgépek napi zárásait (OPG) és a NAV törzsadatot, és ezzel megy az <b>eÁFA</b> gépi kapcsolat is.
      Mindkét környezet hitelesítője eltárolható, és egy kattintással váltható – <b>amelyik aktív, azzal megy minden</b>.
      A kulcsokat kizárólag az ügyfél saját adatainak lekérdezésére használjuk.
    </p>

    <div class="tech-racs" *ngIf="tech">
      <div class="n-panel" *ngFor="let k of techKornyezetek" [class.hasznalt]="tech.aktiv === k">
        <div class="n-panel-cim" style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
          {{ k === 'teszt' ? 'Teszt hitelesítő' : 'Éles hitelesítő' }}
          <span class="cimke" [class.zold]="tech[k].kesz" [class.sarga]="!tech[k].kesz">{{ tech[k].kesz ? 'kész' : 'hiányos' }}</span>
          <span class="cimke petrol" *ngIf="tech.aktiv === k">aktív – ezzel megy minden</span>
          <span class="spacer"></span>
          <button type="button" class="ov-gomb" *ngIf="tech.aktiv !== k" [disabled]="techFut || !tech[k].kesz" (click)="techValt(k)">
            <ion-icon name="swap-horizontal-outline"></ion-icon>Ezt használom</button>
        </div>
        <p class="halvany" style="margin:-4px 0 8px;font-size:12px">
          {{ k === 'teszt'
            ? 'A NAV TESZT rendszerében (onlineszamla-test.nav.gov.hu) létrehozott felhasználó – a lekérések és az eÁFA a tesztkörnyezetbe mennek.'
            : 'Az éles Online Számla rendszerben létrehozott felhasználó – valódi adatok, valódi beküldés.' }}
        </p>
        <label class="kv-mezo"><span>Technikai felhasználó</span>
          <input type="text" [(ngModel)]="techUrlap[k].login" [placeholder]="tech[k].login || 'login'"></label>
        <label class="kv-mezo"><span>Adószám (8 jegy)</span>
          <input type="text" [(ngModel)]="techUrlap[k].adoszam" maxlength="8" [placeholder]="tech[k].adoszam || ''"></label>
        <label class="kv-mezo"><span>Jelszó</span>
          <input type="password" [(ngModel)]="techUrlap[k].jelszo" autocomplete="new-password"
                 [placeholder]="tech[k].van_jelszo ? 'mentve – üresen hagyva megmarad' : ''"></label>
        <label class="kv-mezo"><span>Aláírókulcs</span>
          <input type="text" [(ngModel)]="techUrlap[k].signkey" [placeholder]="tech[k].van_signkey ? 'mentve – üresen hagyva megmarad' : ''"></label>
        <label class="kv-mezo"><span>Cserekulcs</span>
          <input type="text" [(ngModel)]="techUrlap[k].exchangekey" [placeholder]="tech[k].van_exchangekey ? 'mentve' : 'csak számlabeküldéshez kell'"></label>
        <div class="tech-gombok">
          <button type="button" class="ov-gomb fo" [disabled]="techFut === 'ment-' + k" (click)="techMent(k)">
            <ion-icon name="save-outline"></ion-icon>Mentés</button>
          <button type="button" class="ov-gomb" *ngIf="tech.aktiv === k" (click)="tesztOsa()" [disabled]="osaTeszteles">
            <ion-icon [name]="osaTeszteles ? 'hourglass-outline' : 'pulse-outline'"></ion-icon>Online Számla próba</button>
          <button type="button" class="ov-gomb" *ngIf="tech.aktiv === k" [disabled]="eafaFut || !eafaKapcs?.kesz" (click)="eafaProba()">
            <ion-icon [name]="eafaFut === 'proba' ? 'hourglass-outline' : 'pulse-outline'"></ion-icon>eÁFA próba</button>
        </div>
        <p class="halvany tech-lab" *ngIf="tech.aktiv === k && eafaKapcs">
          eÁFA: <code>{{ eafaKapcs.bazis }}</code>
          <ng-container *ngIf="eafaKapcs.utolso_proba"> · utolsó próba: {{ eafaKapcs.utolso_proba | date:'yyyy.MM.dd HH:mm' }} – {{ eafaKapcs.utolso_eredmeny }}</ng-container>
        </p>
      </div>
    </div>

    <!-- Ügyfél-szintű kapcsoló: a számlaképek automatikus letöltése a kimenő szinkronnal. -->
    <div class="n-panel tech-kapcsolo" *ngIf="tech">
      <label class="kv-kapcs"><input type="checkbox" [(ngModel)]="tech.kep_auto" (ngModelChange)="kepAutoMent($event)">
        Számlaképek automatikus letöltése a <b>kimenő</b> Online Számla szinkronnal</label>
      <p class="halvany" style="margin:4px 0 0;font-size:12px">
        Az Online Számla csak adatot ad; a számla képét a NAV Számlázóból hozzuk le. Bekapcsolva a kimenő lekérés
        után a hiányzó képeket egy belépéssel letöltjük és hozzákötjük a könyvelt tételhez. Ehhez Ügyfélkapu-fiók kell,
        és csak a NAV Számlázóban kiállított számlához van kép.
      </p>
    </div>

    <!-- Számlázóprogram (Billingo / Számlázz.hu): a kimenő számlák KÉPE az ügyfél saját kulcsával. -->
    <div class="n-panel" *ngIf="szamlazo">
      <div class="n-panel-cim" style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
        Számlázóprogram – számlaképek
        <span class="spacer"></span>
        <button type="button" class="ov-gomb" [disabled]="szamlazoFut || !szamlazoVanAktiv" (click)="szamlazoLetolt()">
          <ion-icon [name]="szamlazoFut === 'letolt' ? 'hourglass-outline' : 'cloud-download-outline'"></ion-icon>Hiányzó képek letöltése most</button>
      </div>
      <p class="halvany" style="margin:-4px 0 10px;font-size:12px">
        Ha az ügyfél a kimenő számláit <b>Billingóval</b> vagy <b>Számlázz.hu-val</b> állítja ki, a számlák képét az ügyfél
        saját API-kulcsával onnan töltjük le – Ügyfélkapu nélkül, a kimenő Online Számla szinkron után automatikusan
        (és a Szinkron oldalon ütemezve is). A kulcsot <b>csak olvasásra</b> használjuk: számlát nem állítunk ki és nem küldünk vele.
        A beszállítók számláihoz ez nem ad képet (azokhoz az ő kulcsuk kellene).
      </p>
      <div class="tech-racs">
        <div class="n-panel" *ngFor="let k of szamlazo.kapcsolatok" [class.hasznalt]="k.van_kulcs && k.aktiv">
          <div class="n-panel-cim" style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
            {{ k.nev }}
            <span class="cimke" [class.zold]="k.van_kulcs && k.aktiv" [class.sarga]="!k.van_kulcs || !k.aktiv">
              {{ !k.van_kulcs ? 'nincs beállítva' : (k.aktiv ? 'aktív' : 'kikapcsolva') }}</span>
            <span class="cimke petrol" *ngIf="k.letoltve_db">{{ k.letoltve_db }} számlakép</span>
          </div>
          <label class="kv-mezo"><span>{{ k.szolgaltato === 'szamlazz' ? 'Számla Agent kulcs' : 'API-kulcs' }}</span>
            <input type="password" autocomplete="new-password" [(ngModel)]="szamlazoUrlap[k.szolgaltato].kulcs"
                   [placeholder]="k.van_kulcs ? 'mentve – üresen hagyva megmarad' : (k.szolgaltato === 'szamlazz' ? 'Számlázz.hu → Beállítások → Számla Agent kulcsok' : 'Billingo → Beállítások → API')"></label>
          <label class="kv-mezo" *ngIf="k.szolgaltato === 'szamlazz'"><span>Próba-számlaszám (nem kötelező)</span>
            <input type="text" [(ngModel)]="szamlazoProbaSzam" placeholder="pl. E-ABC-2026-1"></label>
          <label class="kv-kapcs"><input type="checkbox" [(ngModel)]="szamlazoUrlap[k.szolgaltato].aktiv"> Használjuk a képletöltéshez</label>
          <div class="tech-gombok">
            <button type="button" class="ov-gomb fo" [disabled]="szamlazoFut" (click)="szamlazoMent(k)">
              <ion-icon name="save-outline"></ion-icon>Mentés</button>
            <button type="button" class="ov-gomb" *ngIf="k.van_kulcs" [disabled]="szamlazoFut" (click)="szamlazoProba(k)">
              <ion-icon [name]="szamlazoFut === 'proba-' + k.szolgaltato ? 'hourglass-outline' : 'pulse-outline'"></ion-icon>Kapcsolat próbája</button>
            <button type="button" class="ov-gomb" *ngIf="k.van_kulcs" [disabled]="szamlazoFut" (click)="szamlazoTorol(k)">
              <ion-icon name="trash-outline"></ion-icon>Törlés</button>
          </div>
          <p class="halvany tech-lab" *ngIf="k.utolso_proba">
            Utolsó próba: {{ k.utolso_proba | date:'yyyy.MM.dd HH:mm' }} – {{ k.utolso_eredmeny }}</p>
        </div>
      </div>
      <p class="halvany" style="margin:8px 0 0;font-size:12px" *ngIf="szamlazo.allapot?.nincs">
        {{ szamlazo.allapot.nincs }} kimenő számla nem található a számlázóprogramban (ezeket 7 napig nem kérdezzük újra).
        <a href="javascript:void(0)" (click)="szamlazoLetolt(true)">Most mégis újrapróbálom</a>
      </p>
    </div>
  </div>

  <!-- NAV TÖRZSADAT – a táblák TELJES szélességben (mint a többi fül), nincs max-width korlát -->
  <div *ngIf="nezet === 'navtorzs'">
    <div class="n-szuro-sor">
      <button type="button" class="ov-gomb fo" (click)="frissitNavTorzs()" [disabled]="!navtorzsMeta.konfiguralt || navtorzsBetolt">
        <ion-icon [name]="navtorzsBetolt ? 'hourglass-outline' : 'sync-outline'"></ion-icon>{{ navtorzsBetolt ? 'Frissítés…' : 'NAV törzsadat frissítése' }}</button>
      <button type="button" class="ov-gomb" (click)="letoltNavTorzsPdf()" [disabled]="!navtorzs">
        <ion-icon name="document-outline"></ion-icon>PDF letöltés</button>
      <span class="spacer"></span>
      <span class="halvany" *ngIf="navtorzsMeta.utolso_szinkron">Utolsó szinkron: {{ navtorzsMeta.utolso_szinkron | date:'yyyy.MM.dd HH:mm' }}</span>
    </div>

    <!-- History-választó: vissza lehet nézni a korábbi lekéréseket (mindig a legfrissebb az alap) -->
    <div class="n-panel navtorzs-valaszto">
      <label class="kv-mezo" *ngIf="navtorzsHistory.length > 1"><span>Lekérés időpontja</span>
        <select [ngModel]="navtorzsAktivId" (ngModelChange)="valasztTorzsVerzio($event)">
          <option *ngFor="let h of navtorzsHistory; let i = index" [ngValue]="h.id">
            {{ h.lekerve | date:'yyyy.MM.dd HH:mm' }}{{ i === 0 ? ' — legfrissebb' : '' }}</option>
        </select></label>
    <div *ngIf="navtorzs && !navtorzsLegfrissebb" class="navtorzs-regi">
      <ion-icon name="alert-circle-outline"></ion-icon> Egy korábbi lekérést nézel. A legfrissebbhez válaszd a lista első („legfrissebb") elemét.
    </div>

      <!-- Forrás-kapcsoló: ÜPO / eBEV (hivatalos, gazdag) | OSA (API-részhalmaz) -->
      <label class="kv-mezo"><span>Törzsadat forrása</span>
        <select [ngModel]="navtorzsMeta.forras" (ngModelChange)="valtTorzsForras($event)">
          <option value="upo">ÜPO – hitelesített, teljes törzsadat (Ügyfélkapu) – ajánlott</option>
          <option value="ebev">eBEV – teljes törzsadat (Ügyfélkapu) – kivezetés alatt</option>
          <option value="osa">OSA queryTaxpayer – alapadatok (technikai felhasználó)</option>
        </select></label>
    </div>

    <!-- Nincs meg a forráshoz szükséges hozzáférés -->
    <div class="ures" *ngIf="!navtorzsMeta.konfiguralt && navtorzsMeta.forras !== 'osa'">
      <ion-icon name="key-outline"></ion-icon>
      Az <b>eBEV</b> forráshoz <b>Ügyfélkapu-fiók</b> hozzárendelése kell ehhez az ügyfélhez
      (Tárhely-fiókok). Enélkül válaszd az <b>OSA</b> forrást.
    </div>
    <div class="ures" *ngIf="!navtorzsMeta.konfiguralt && navtorzsMeta.forras === 'osa'">
      <ion-icon name="key-outline"></ion-icon>
      Az <b>OSA</b> forráshoz állítsd be az ügyfél <b>NAV technikai felhasználóját</b> az
      <b>„OSA / NAV"</b> fülön (login + adószám + jelszó + aláírókulcs).
    </div>

    <!-- Még nincs lekért adat -->
    <div class="ures" *ngIf="navtorzsMeta.konfiguralt && !navtorzs">
      <ion-icon name="cloud-download-outline"></ion-icon>
      Még nincs lekért NAV törzsadat. Kattints a <b>NAV törzsadat frissítése</b> gombra.
    </div>

    <!-- Fejléc-mezők + MINDEN szekció-tábla (a NAV PDF-jéből kiolvasva) – teljes szélességben -->
    <ng-container *ngIf="navtorzs">
      <h4 class="szekcio" style="margin-top:10px">
        {{ navtorzs.nev || navtorzs.rovid_nev || 'NAV törzsadat' }}
        <small class="halvany">– {{ torzsForrasNev(navtorzs.forras) }}</small>
      </h4>
      <div class="tabla-wrap" *ngIf="torzsMezok.length">
        <table class="n-racs navtorzs-mezok">
          <tbody>
            <tr *ngFor="let m of torzsMezok"><th style="text-align:left; width:28%">{{ m.cimke }}</th><td>{{ m.ertek }}</td></tr>
          </tbody>
        </table>
      </div>

      <!-- Szekció-táblák (TEÁOR, címek, bankszámlák, tulajdonosok, képviselők, jellemzők…) -->
      <ng-container *ngFor="let tb of torzsTablak">
        <h4 class="szekcio">{{ tb.cim }} <small class="halvany">({{ tb.sorok.length }})</small></h4>
        <div class="tabla-wrap">
          <table class="n-racs">
            <thead><tr><th *ngFor="let f of tb.fejlec">{{ f }}</th></tr></thead>
            <tbody>
              <tr *ngFor="let s of tb.sorok"><td *ngFor="let c of s">{{ c }}</td></tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<!-- ===== MODALOK ===== -->
<ion-modal #rovatModal class="kozep-modal" (didDismiss)="zarEngedd()">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff"><ion-title>Rovat</ion-title>
      <ion-buttons slot="end"><ion-button (click)="rovatModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>
      <ion-item><ion-label position="stacked">Rovatszám *</ion-label><ion-input [(ngModel)]="szerk.rovatszam" [disabled]="!!szerk.id"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Név *</ion-label><ion-input [(ngModel)]="szerk.nev"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Típus</ion-label>
        <ion-select [(ngModel)]="szerk.tipus" interface="popover">
          <ion-select-option *ngFor="let t of opciok.rovatTipus" [value]="t.value">{{ t.label }}</ion-select-option>
        </ion-select></ion-item>
      <ion-item *ngIf="szerk.tipus === 'rovat'"><ion-label position="stacked">Fő oszlop (1-7)</ion-label>
        <ion-select [(ngModel)]="szerk.oszlop" interface="popover">
          <ion-select-option *ngFor="let o of opciok.fooszlopok" [value]="o.value">{{ o.label }}</ion-select-option>
        </ion-select></ion-item>
      <ion-item><ion-checkbox slot="start" [(ngModel)]="szerk.afas"></ion-checkbox><ion-label>ÁFÁ-s</ion-label></ion-item>
      <ion-item *ngIf="szerk.afas"><ion-label position="stacked">Alap ÁFA %</ion-label>
        <ion-select [(ngModel)]="szerk.alap_afa_kulcs" interface="popover">
          <ion-select-option [value]="null">–</ion-select-option>
          <ion-select-option *ngFor="let k of opciok.afaKulcsok" [value]="k">{{ k }}%</ion-select-option>
        </ion-select></ion-item>
      <ion-item *ngIf="szerk.afas"><ion-checkbox slot="start" [(ngModel)]="szerk.afa_modosithato"></ion-checkbox><ion-label>ÁFA értéke módosítható</ion-label></ion-item>
      <ion-item *ngIf="szerk.tipus === 'rovat'"><ion-checkbox slot="start" [(ngModel)]="szerk.forditott_afa"></ion-checkbox><ion-label>Fordított ÁFA felajánlása</ion-label></ion-item>
      <!-- Az összesítő nyilatkozat (A60) kategóriája: ha a partner „összesítő nyilatkozat” jelzős, ezen a
           rovaton könyvelt összeg termékként vagy szolgáltatásként kerül a 26A60-ba. -->
      <ion-item *ngIf="szerk.tipus === 'rovat'">
        <ion-select [(ngModel)]="szerk.osszesito" interface="popover" label="Összesítő nyilatkozat (A60)" labelPlacement="stacked" placeholder="– nem közösségi ügylet –">
          <ion-select-option [value]="null">– nem közösségi ügylet –</ion-select-option>
          <ion-select-option value="termek">Termék (értékesítés / beszerzés)</ion-select-option>
          <ion-select-option value="szolgaltatas">Szolgáltatás (nyújtás / igénybevétel)</ion-select-option>
        </ion-select></ion-item>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" [disabled]="zarTilt" (click)="mentRovat()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal #oszlopModal class="kozep-modal">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff"><ion-title>Oszlop-pár</ion-title>
      <ion-buttons slot="end"><ion-button (click)="oszlopModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <ion-item><ion-label position="stacked">Sorszám (1-6)</ion-label>
        <ion-select [(ngModel)]="szerk.sorszam" interface="popover">
          <ion-select-option *ngFor="let n of [1,2,3,4,5,6]" [value]="n">{{ n }}</ion-select-option>
        </ion-select></ion-item>
      <ion-item><ion-label position="stacked">Típus</ion-label>
        <ion-select [(ngModel)]="szerk.tipus" interface="popover">
          <ion-select-option *ngFor="let t of opciok.oszlopTipus" [value]="t.value">{{ t.label }}</ion-select-option>
        </ion-select></ion-item>
      <ion-item><ion-label position="stacked">Oszlop fejléc</ion-label><ion-input [(ngModel)]="szerk.fejlec"></ion-input></ion-item>
      <ion-list-header>Csökkenő oszlop</ion-list-header>
      <ion-item><ion-label position="stacked">Rovatszám (pl. XK1)</ion-label><ion-input [(ngModel)]="szerk.csokkeno_rovat"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Megnevezés</ion-label><ion-input [(ngModel)]="szerk.csokkeno_nev"></ion-input></ion-item>
      <ion-list-header>Növekvő oszlop</ion-list-header>
      <ion-item><ion-label position="stacked">Rovatszám (pl. XK2)</ion-label><ion-input [(ngModel)]="szerk.novekvo_rovat"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Megnevezés</ion-label><ion-input [(ngModel)]="szerk.novekvo_nev"></ion-input></ion-item>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" (click)="mentOszlop()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal #partnerModal class="kozep-modal" (didDismiss)="zarEngedd()">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff"><ion-title>Partner</ion-title>
      <ion-buttons slot="end"><ion-button (click)="partnerModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>
      <ion-item><ion-label position="stacked">Név (teljes) *</ion-label><ion-input [(ngModel)]="szerk.nev"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Rövid név (könyvelésben ez jelenik meg)</ion-label><ion-input [(ngModel)]="szerk.rovid_nev"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Adószám</ion-label><ion-input [(ngModel)]="szerk.adoszam"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Közösségi adószám</ion-label><ion-input [(ngModel)]="szerk.kozossegi_adoszam" placeholder="pl. DE123456789"></ion-input>
        <ion-button slot="end" size="small" fill="solid" class="vies-gomb" [disabled]="viesFut || !(szerk.kozossegi_adoszam || szerk.adoszam)" (click)="partnerVies()"
                    title="Ellenőrzés az EU VIES rendszerében (díjmentes) – üresen a magyar adószámból képzi">EU</ion-button></ion-item>
      <div class="vies-ered" *ngIf="vies" [class.jo]="vies.ok && vies.ervenyes" [class.rossz]="!vies.ok || !vies.ervenyes">
        {{ vies.ok ? (vies.ervenyes ? '✓ Érvényes közösségi adószám' : '✗ Nem érvényes közösségi adószám') : vies.hiba }}
        <ng-container *ngIf="vies.nev"> · {{ vies.nev }}</ng-container><ng-container *ngIf="vies.cim"> · {{ vies.cim }}</ng-container></div>
      <ion-grid><ion-row>
        <ion-col size="4"><ion-item><ion-label position="stacked">Irsz</ion-label><ion-input [(ngModel)]="szerk.irsz"></ion-input></ion-item></ion-col>
        <ion-col size="8"><ion-item><ion-label position="stacked">Település</ion-label><ion-input [(ngModel)]="szerk.telepules"></ion-input></ion-item></ion-col>
      </ion-row></ion-grid>
      <ion-item><ion-label position="stacked">Cím</ion-label><ion-input [(ngModel)]="szerk.cim"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Alap rovat – bevétel</ion-label><ion-input [(ngModel)]="szerk.bevetel_rovat"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Alap rovat – kiadás</ion-label><ion-input [(ngModel)]="szerk.kiadas_rovat"></ion-input></ion-item>
      <ion-item><ion-checkbox slot="start" [(ngModel)]="szerk.kata"></ion-checkbox><ion-label>KATA alany</ion-label></ion-item>
      <ion-item><ion-checkbox slot="start" [(ngModel)]="szerk.osszesito_nyilatkozat"></ion-checkbox><ion-label>Összesítő nyilatkozat</ion-label></ion-item>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" [disabled]="zarTilt" (click)="mentPartner()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal #gyujtoModal class="kozep-modal" (didDismiss)="zarEngedd()">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff"><ion-title>Gyűjtő</ion-title>
      <ion-buttons slot="end"><ion-button (click)="gyujtoModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>
      <ion-item><ion-label position="stacked">Kód (max 2) *</ion-label><ion-input [(ngModel)]="szerk.kod" maxlength="2" [disabled]="!!szerk.id"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Név *</ion-label><ion-input [(ngModel)]="szerk.nev"></ion-input></ion-item>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" [disabled]="zarTilt" (click)="mentGyujto()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal #penztarModal class="kozep-modal" (didDismiss)="zarEngedd()">
  <ng-template>
    <ion-header><ion-toolbar style="--background:var(--naplo); --color:#fff"><ion-title>Pénztár / Bank</ion-title>
      <ion-buttons slot="end"><ion-button (click)="penztarModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <ion-content class="ion-padding" *ngIf="szerk">
      <app-szerk-zar-sav [zar]="zar"></app-szerk-zar-sav>
      <ion-item><ion-label position="stacked">Azonosító (1 betű/szám) *</ion-label><ion-input [(ngModel)]="szerk.azonosito" maxlength="2" [disabled]="!!szerk.id"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Név *</ion-label><ion-input [(ngModel)]="szerk.nev"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Típus</ion-label>
        <ion-select [(ngModel)]="szerk.tipus" interface="popover">
          <ion-select-option *ngFor="let t of opciok.penztarTipus" [value]="t.value">{{ t.label }}</ion-select-option>
        </ion-select></ion-item>
      <ion-item><ion-label position="stacked">Devizanem</ion-label><ion-input [(ngModel)]="szerk.devizanem"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Bankszámlaszám</ion-label><ion-input [(ngModel)]="szerk.bankszamla"></ion-input></ion-item>
      <ion-item><ion-label position="stacked">Nyitó egyenleg</ion-label><ion-input type="number" [(ngModel)]="szerk.nyito_egyenleg"></ion-input></ion-item>
      <ion-button expand="block" class="ion-margin-top" style="--background:var(--naplo)" [disabled]="zarTilt" (click)="mentPenztar()">Mentés</ion-button>
    </ion-content>
  </ng-template>
</ion-modal>
